import { Validators } from '@angular/forms';

export class BalloonAmountModel {
    amount = {
        value: 0.00,
        validation: Validators.compose([
            Validators.required
        ])
    };
    percentage = {
        value: null,
        validation: Validators.compose([
            Validators.required,
            Validators.max(30)
        ])
    };
}
